import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Search from "@/pages/Search";
import ProfileView from "@/pages/ProfileView";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import MyMatches from "@/pages/MyMatches";
import Chat from "@/pages/Chat";
import Notifications from "@/pages/Notifications";
import Verification from "@/pages/Verification";
import AdminVerifications from "@/pages/AdminVerifications";
import AdminReports from "@/pages/AdminReports";
import AdminMembers from "@/pages/AdminMembers";
import AdminAudit from "@/pages/AdminAudit";
import AdminUsage from "@/pages/AdminUsage";
import BlockedUsers from "@/pages/BlockedUsers";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import MobileBridge from "@/pages/MobileBridge";
import EditProfile from "@/pages/EditProfile";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Shell() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/mobile-bridge" element={<MobileBridge />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/profile/edit" element={<Protected><EditProfile /></Protected>} />
        <Route path="/search" element={<Protected><Search /></Protected>} />
        <Route path="/profile/:id" element={<Protected><ProfileView /></Protected>} />
        <Route path="/matches" element={<Protected><MyMatches /></Protected>} />
        <Route path="/chat" element={<Protected><Chat /></Protected>} />
        <Route path="/chat/:otherId" element={<Protected><Chat /></Protected>} />
        <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
        <Route path="/verification" element={<Protected><Verification /></Protected>} />
        <Route path="/admin/verifications" element={<Protected><AdminVerifications /></Protected>} />
        <Route path="/admin/reports" element={<Protected><AdminReports /></Protected>} />
        <Route path="/admin/members" element={<Protected><AdminMembers /></Protected>} />
        <Route path="/admin/audit" element={<Protected><AdminAudit /></Protected>} />
        <Route path="/admin/usage" element={<Protected><AdminUsage /></Protected>} />
        <Route path="/blocked" element={<Protected><BlockedUsers /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <Shell />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
